module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/outline-icons-261d666b0147c6c5cda07265f98b8f8c.eot";